import api from './api';

export const getVaultByUuid = (uuid) => api.get(`/v1/vault/${uuid}`);

export const listVaults = (body) => api.post(`/v1/workspace/vault/list`, body);

export const updateVault = (uuid, tenantId, body) => api.post(`/v1/vault/${uuid}/update`, body, { params: { tenantId } });

export const createVault = (body) => api.post(`/v1/vault/create`, body);

export const getVaultFolder = (body) => api.post(`/v1/tenant/vault/get_folder`, body);

export const unassignAgentFromVault = (vaultUuid, agentUuid) => 
  api.post(`/v1/workspace/vault/${vaultUuid}/agent/unassign`, { agent_uuid: agentUuid });

export const assignAgentToVault = (vaultUuid, agentUuid, privilege = 'READER', description = '') => 
  api.post(`/v1/workspace/vault/${vaultUuid}/agent`, {
    agent_uuid: agentUuid,
    privilege: privilege,
    description: description,
  });
